import { useTranslation } from "react-i18next";

import VerticalMenu from "../../../ui/components/VerticalMenu/VerticalMenu";
import PageView from "../../../ui/views/PageView/PageView";

import useSuperAdminFinanceMenuOptions from "./hooks/useSuperAdminFinanceMenuOptions";

export default function SuperAdminFinanceView({ children }) {
	const { t } = useTranslation();

	const options = useSuperAdminFinanceMenuOptions();

	return (
		<PageView header={t("finance", "Finance")} sidebar={<VerticalMenu options={options} />} maxWidth={1800}>
			{children}
		</PageView>
	);
}
